import { routenames } from '@/router/routenames.ts';
import { useAuthenticationStore } from '@/stores/authenticationStore.ts';
import { useSystemStore } from '@/stores/systemStore.ts';
import type { RouteLocationNormalized } from 'vue-router';
import { getRedirectPathFromRoute } from '../utils';

export async function maintenanceModeGuard(to: RouteLocationNormalized) {
  const systemStore = useSystemStore();
  const authenticationStore = useAuthenticationStore();

  if (
    // We need to check for the unique userName instead of the userId, because
    // userIds are not unique between database instances (Autoincrement of userId, which is an integer)
    systemStore.maintenanceModeInfo?.userName
  ) {
    const isMaintenanceUser =
      systemStore.maintenanceModeInfo.userName === authenticationStore.session?.userName;

    const redirect = getRedirectPathFromRoute(to);
    if (!isMaintenanceUser) {
      if (authenticationStore.isAuthenticated && to.name !== routenames.signOut)
        return { name: routenames.signOut };
      if (!authenticationStore.isAuthenticated && to.name !== routenames.signIn) {
        return { name: routenames.signIn, query: { redirect } };
      }
    }
  }
}
